import { Heart, ShoppingCart, User, Menu, X } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useCart } from '../context/CartContext'
import styles from '../styles/Navbar.module.css'
import PropTypes from 'prop-types'

const Navbar = ({ className = '' }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { cart } = useCart()

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)

  return (
    <>
    <nav className={`${styles.navbar} ${className}`}>
      <Link to='/' className={styles.logo}>
        <img src='/b-sublogo.webp' loading='eager' className={styles.imageLogo} alt='Óptica Natalú' />
      </Link>

      <button aria-label='Toggle menu' className={styles.menuButton} onClick={toggleMenu}>
        {isMenuOpen ? <X /> : <Menu />}
      </button>

      <div className={`${styles.navLinks} ${isMenuOpen ? styles.navLinksOpen : ''}`}>
        <Link to='/' className={styles.navLink}>
          INICIO
        </Link>
        <Link to='/tienda' className={styles.navLink}>
          TIENDA
        </Link>
        <Link to='/ofertas' className={styles.navLink}>
          OFERTAS
        </Link>
        <Link to='/reservas' className={styles.navLink}>
          RESERVAS
        </Link>
        <Link to='/contacto' className={styles.navLink}>
          CONTACTO
        </Link>
      </div>

      <div className={styles.navIcons}>
        <Link to='/lista-de-deseos' aria-label='Lista de deseos' className={styles.iconButton}>
          <Heart />
        </Link>
        <Link to='/carrito' aria-label='Carrito de compras' className={styles.iconButton}>
          <ShoppingCart />
          {cart.length > 0 && <span className={styles.cartBadge}>{cart.length}</span>}
        </Link>
        <Link to='/login' aria-label='Inicio de sesión' className={styles.iconButton}>
          <User />
        </Link>
      </div>

    </nav>
      {isMenuOpen && <div className={`${styles.navOverlay} && ${styles.navOverlayOpen}`} onClick={toggleMenu}></div>}
    </>
  )
}

Navbar.propTypes = {
  className: PropTypes.string,
}

export default Navbar
